import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Navigation from './Navigation';
import Footer from './Footer';

const Imprint = () => {
  return (
    <PageContainer>
      <Navigation />
      <Section>
        <ContentWrapper>
          <PagePill>Legal Notice</PagePill>

          <MainHeading>Imprint</MainHeading>

          <ContentSection>
            <SectionHeading>Information According to § 5 TMG</SectionHeading>
            <InfoText>
              Mohamed Elgazzar<br />
              Quartiersweg 6<br />
              10829 Berlin<br />
              Germany
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Contact</SectionHeading>
            <InfoText>
              Email: hello@sonorai.co
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Legal Status</SectionHeading>
            <InfoText>
              This website is operated by Mohamed Elgazzar as an individual.
              Sonor AI is not incorporated as a company and operates as a sole proprietorship.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Liability for Content</SectionHeading>
            <InfoText>
              The contents of our pages have been created with the utmost care. However, we cannot guarantee the contents'
              accuracy, completeness, or topicality. According to statutory provisions, we are furthermore responsible for
              our own content on these web pages. In this matter, please note that we are not obliged to monitor
              the transmitted or saved information of third parties, or investigate circumstances pointing to illegal activity.
              Our obligations to remove or block the use of information under generally applicable laws remain unaffected by this
              as per §§ 8 to 10 of the Telemedia Act (TMG).
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Liability for Links</SectionHeading>
            <InfoText>
              Our offer includes links to external third-party websites, such as Cal.com for booking services. We have no influence on the content
              of those websites, therefore we cannot guarantee for those contents. Providers or administrators of linked websites are always
              responsible for their own content. The linked websites had been checked for possible violations of law at the time of the
              establishment of the link. Illegal contents were not detected at the time of the linking. A permanent monitoring of the contents
              of linked websites cannot be imposed without reasonable indications that there has been a violation of law.
              Upon notification of violations, we will remove such links immediately.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>Copyright</SectionHeading>
            <InfoText>
              The contents and works on these pages created by the site operators are subject to German copyright law.
              The duplication, processing, distribution, and any kind of utilization outside the boundaries of copyright
              law require the written consent of the respective author or creator. Downloads and copies of these pages
              are only permitted for private, non-commercial use. In so far as the content on this site was not created
              by the operator, the copyrights of third parties are respected. In particular, third-party content is marked as such.
              Should you become aware of a copyright infringement, please inform us accordingly. Upon notification of violations,
              we will remove such content immediately.
            </InfoText>
          </ContentSection>
        </ContentWrapper>
      </Section>
      <Footer />
    </PageContainer>
  );
};

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: var(--color-dark-600);
  background-image: radial-gradient(rgba(255, 255, 255, 0.08) 1px, transparent 1px);
  background-size: 20px 20px;
`;

const Section = styled.section`
  padding: 160px 20px 100px;
  max-width: 1200px;
  margin: 0 auto;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 800px;
  margin: 0 auto;
`;

const PagePill = styled.div`
  display: inline-block;
  padding: 8px 20px;
  background-color: rgba(17, 17, 17, 0.9);
  border-radius: 50px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 30px;
  align-self: flex-start;
`;

const MainHeading = styled.h1`
  font-size: 38px;
  font-weight: 700;
  color: white;
  margin-bottom: 40px;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 32px;
  }

  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

const ContentSection = styled.div`
  margin-bottom: 40px;
`;

const SectionHeading = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: var(--color-ui-orange);
  margin-bottom: 16px;

  @media (max-width: 768px) {
    font-size: 22px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

const InfoText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  color: var(--color-text-light);
  margin-bottom: 16px;
`;

export default Imprint;
